import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const AppointmentTitle: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="mb-8 flex flex-col md:flex-row md:items-center justify-between gap-2">
      <h1 className="text-3xl font-bold">
        {t("back.management.appointment.title")}
      </h1>
      <button
        onClick={() => navigate("/appointments/create")}
        className="hover:bg-primary-red flex items-center gap-2 rounded-md bg-red-500 px-4 py-2 text-white w-fit"
      >
        <FontAwesomeIcon icon={faPlus} />
        {t("back.management.appointment.create")}
      </button>
    </div>
  );
};

export default AppointmentTitle;
